module.exports = __webpack_public_path__ + "img/Z71_06.b085ae74.jpg";